import {
  AdvisorUI,
  BasicStyleRegistry,
  ComponentStylesDefinitions,
  CreateWebDesignClass,
} from "@zoovu/runner-browser-api";
import { ComponentRegistryFactory, StyleRegistryFactory } from "@zoovu/runner-web-design-base";
import { AutoForwardPlugin, DataAttributesReaderPlugin } from "@zoovu/runner-web-design-base/src/plugins";

/* eslint-disable no-underscore-dangle */
declare const __WEB_DESIGN__VERSION__: string;
declare const __WEB_DESIGN__GIT_COMMIT_HASH__: string;
declare const __WEB_DESIGN__GIT_BRANCH__: string;
/* eslint-enable no-underscore-dangle */

declare const window: Window & {
  advisorUI: AdvisorUI;
};

const componentRegistry = ComponentRegistryFactory.createComponentRegistry();
const context = require.context("./components", false, /\.vue$/);
context.keys().forEach((key) => {
  const component = context(key).default;
  componentRegistry.addOrOverrideComponent(component.options.name.replace(/Extended$/, ""), component);
});

const createStylesRegistry = (): BasicStyleRegistry => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
  const styles = require("./styles").default;
  const componentStylesDefinitions: ComponentStylesDefinitions = {};
  componentRegistry.getComponentNames().forEach((name) => {
    let componentStyle =
      styles[`${name}Style`] ||
      styles[`${name.substring(0, name.indexOf("View"))}Style`] ||
      styles[`${name.substring(0, name.indexOf("Extended"))}Style`];

    if (!componentStyle) {
      componentStyle = { container: {} };
    }
    componentStylesDefinitions[name] = componentStyle;
  });

  const rootContainerStyle = styles.RootContainerStyle;
  return StyleRegistryFactory.createStyleRegistry(componentStylesDefinitions, rootContainerStyle);
};

const WebDesignClass = CreateWebDesignClass({
  webDesignName: "ThemeArgon2",
  AdvisorView: componentRegistry.getComponent("AdvisorView"),
  componentRegistry,
  styleRegistry: createStylesRegistry(),
  plugins: [AutoForwardPlugin, DataAttributesReaderPlugin],
  versionDescriptor: {
    version: __WEB_DESIGN__VERSION__,
    git: {
      branch: __WEB_DESIGN__GIT_BRANCH__,
      commitHash: __WEB_DESIGN__GIT_COMMIT_HASH__,
    },
  },
});

if (module.hot) {
  module.hot.accept("./styles", () => {
    (window.advisorUI as AdvisorUI).updateComponentsStyleSheets(createStylesRegistry());
  });
}

export default WebDesignClass;
